import { Paper } from "@mantine/core";
import { Dropdown, Input, Menu, Select, DatePicker } from "antd";
import React, { useState } from "react";
import { isWithinDateRange } from "../../helpers/date-range";

export default function BillsFilterBar({
  data,
  onFilter,
  onReset,
  excelExport,
}) {
  const { Search } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const [filters, setFilters] = useState({
    search: "",
    status: "all",
    dateRange: null,
  });

  const onMenuClick = (e) => {
    if (e.key === "1") excelExport();
    // if ( e.key === "2" ) alert( 'pdf' );
    // if ( e.key === "3" ) alert( 'email' );
  };

  const applyFilters = (newFilters) => {
    setFilters(newFilters);

    let filteredData = data || [];

    // Apply search filter
    if (newFilters.search) {
      const searchTerm = newFilters.search.toLowerCase();
      filteredData = filteredData.filter((p) => {
        const memberName = `${p.patient?.firstName || ""} ${
          p.patient?.lastName || ""
        }`.toLowerCase();
        const billNumber = (p.billNumber || "").toLowerCase();

        // Calculate amount paid from payments
        const amountPaid =
          p.payments?.reduce(
            (sum, payment) => sum + (parseFloat(payment.amount) || 0),
            0
          ) || 0;
        const amountPaidStr = amountPaid.toString().toLowerCase();

        // Calculate amount due from items
        const amountDue =
          p.items?.reduce(
            (sum, item) =>
              sum +
              (parseFloat(item.rate) || 0) * (parseFloat(item.quantity) || 0),
            0
          ) || 0;
        const amountDueStr = amountDue.toString().toLowerCase();

        // Determine status based on amount paid
        const status = amountPaid > 0 ? "paid" : "unpaid";

        return (
          memberName.includes(searchTerm) ||
          billNumber.includes(searchTerm) ||
          amountPaidStr.includes(searchTerm) ||
          amountDueStr.includes(searchTerm) ||
          status.includes(searchTerm)
        );
      });
    }

    // Apply status filter
    if (newFilters.status && newFilters.status !== "all") {
      if (newFilters.status === "paid") {
        filteredData = filteredData.filter((d) => {
          const amountPaid =
            d.payments?.reduce(
              (sum, payment) => sum + (parseFloat(payment.amount) || 0),
              0
            ) || 0;
          return amountPaid > 0;
        });
      } else if (newFilters.status === "unpaid") {
        filteredData = filteredData.filter((d) => {
          const amountPaid =
            d.payments?.reduce(
              (sum, payment) => sum + (parseFloat(payment.amount) || 0),
              0
            ) || 0;
          return amountPaid === 0;
        });
      }
    }

    // Apply date range filter
    if (newFilters.dateRange) {
      filteredData = filteredData.filter((d) =>
        isWithinDateRange(
          d.billDate || d.createdAt || d.date,
          newFilters.dateRange
        )
      );
    }

    onFilter(filteredData);
  };

  const handleSearchChange = (e) => {
    const newFilters = { ...filters, search: e.target.value };
    applyFilters(newFilters);
  };

  const handleStatusChange = (value) => {
    const newFilters = { ...filters, status: value };
    applyFilters(newFilters);
  };

  const handleDateRangeChange = (dates) => {
    const newFilters = { ...filters, dateRange: dates };
    applyFilters(newFilters);
  };

  const handleReset = () => {
    const resetFilters = {
      search: "",
      status: "all",
      dateRange: null,
    };
    setFilters(resetFilters);
    onReset();
  };

  const menu = (
    <Menu
      onClick={onMenuClick}
      items={[
        {
          key: "1",
          label: (
            <>
              <span className="bi bi-file-excel me-2"></span>
              Excel
            </>
          ),
        },
        // {
        //     key: "2",
        //     label: <>
        //         <span className='bi bi-file-pdf me-2'></span>
        //         PDF
        //     </>
        // },
        // {
        //     key: "3",
        //     label: <>
        //         <span className='bi bi-envelope me-2'></span>
        //         Email
        //     </>
        // },
      ]}
    />
  );

  return (
    <Paper className="border p-3 d-flex justify-content-between">
      <div className="d-flex align-items-center gap-3">
        <Search
          style={{ maxWidth: "250px" }}
          value={filters.search}
          onChange={handleSearchChange}
          title="search bills"
          placeholder="Search by member name, bill number, amount..."
        />

        <RangePicker
          style={{ maxWidth: "250px" }}
          value={filters.dateRange}
          onChange={handleDateRangeChange}
          placeholder={["Start Date", "End Date"]}
          format="YYYY-MM-DD"
        />

        <Select
          style={{ maxWidth: "200px" }}
          name="byType"
          value={filters.status}
          onChange={handleStatusChange}
          defaultValue="all">
          <Option value="all">All Bills</Option>
          <Option value="paid">Paid</Option>
          <Option value="unpaid">Unpaid</Option>
        </Select>
      </div>
      <div className="d-flex">
        <Dropdown overlay={menu}>
          <button className="app-btn btn-prim d-flex align-items-center">
            <span className="bi bi-file-earmark-arrow-down me-2"></span>
            Export to
          </button>
        </Dropdown>
        {/* <button
                    className="app-btn btn-prim d-flex mx-2 align-items-center">
                    <span className="bi bi-list me-2"></span>
                    More Filters
                </button> */}
        <button
          onClick={handleReset}
          className="app-btn btn-prim d-flex align-items-center ms-2">
          <span className="bi bi-arrow-clockwise me-2"></span>
          Reset filters
        </button>
      </div>
    </Paper>
  );
}
